import { sendForm602SubmissionQuery, usePoMutation } from '@gov-nx/api';

interface Form602SubmissionSendQuery {
	onSuccess?: (
		data: Awaited<ReturnType<typeof sendForm602SubmissionQuery>>
	) => void;
}

export const useForm602SubmissionSendQuery = (
	props?: Form602SubmissionSendQuery
) => {
	const mutation = usePoMutation(
		{
			mutationFn: sendForm602SubmissionQuery,
			onSuccess: (data) => {
				props?.onSuccess?.(data);
			},
		},
		{
			errorIgnoreFilter: () => true,
		}
	);

	return mutation;
};
